import { useSelector } from "react-redux";
import Forma from "./_Forma";

export default function Terminados() {
  const { step } = useSelector((state) => state.cotizacionesReducer.cotizacion);

  return step > 3 ? <Forma /> : <></>;
}
